import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import store from './store'
import VueI18n from 'vue-i18n'
import en from './locales/en'
import it from './locales/it'
import de from './locales/de'
import router from './router'
import './plugins/apexcharts'

Vue.config.productionTip = false

Vue.use(VueI18n)

const messages = {
  en,
  it,
  de
}

// Inizializza i18n con la lingua salvata in localStorage (tramite Vuex store)
const i18n = new VueI18n({
  locale: store.state.language.currentLanguage, // Legge da localStorage o usa lingua del browser
  fallbackLocale: 'en',
  messages
})

// Sincronizza automaticamente la lingua tra Vuex e i18n
// Quando l'utente cambia lingua, viene salvata in localStorage e aggiornata nell'app
store.watch(
  state => state.language.currentLanguage,
  (newLocale) => {
    i18n.locale = newLocale
  }
)

new Vue({
  vuetify,
  store,
  i18n,
  router,
  render: h => h(App)
}).$mount('#app')
